export const DRAWER_OPEN = "DRAWER_OPEN";
export const DRAWER_CLOSE = "DRAWER_CLOSE";

export const openDrawer = (title, content, width = 250) => ({type: DRAWER_OPEN, title, content, width});
export const closeDrawer = () => ({type: DRAWER_CLOSE});
